/** Etat des boutons d'accès aux formulaires */
enum MenuButtonStateEnum {
	/// 
	/** Le bouton d'accès au formulaire est visible */
	Visible = 0,
	/** Le bouton d'accès au formulaire est visible mais désactivé */
	Disabled = 1,
	/** Le bouton d'accès au formulaire est caché */
	Hidden = 2
}

export default MenuButtonStateEnum